/** DiceBear：同一 seed 固定同一头像。文档 https://www.dicebear.com/how-to-use/http-api/ */

const DICEBEAR_AVATAAARS_BASE = "https://api.dicebear.com/7.x/avataaars/svg";

export const resolveAvatarSeed = (userInfo: unknown): string => {
  if (userInfo && typeof userInfo === "object") {
    const u = userInfo as Record<string, unknown>;
    const raw = u.id ?? u.userId ?? u.user_id ?? u.username;
    if (raw !== undefined && raw !== null && String(raw).trim() !== "") {
      return String(raw);
    }
  }
  return "anonymous";
};

export const getDicebearAvataaarsUrl = (userInfo: unknown): string => {
  const seed = encodeURIComponent(resolveAvatarSeed(userInfo));
  return `${DICEBEAR_AVATAAARS_BASE}?seed=${seed}`;
};
